import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { withClientOnly } from '../client-only';
import { useMarketplaceAddCashbackTransaction } from '../../graphql/hooks/use-marketplace-add-cashback-transaction';
import { extractStringFromQuery } from '../../lib/query-string';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CashbackTransactionDetector = () => {
  const router = useRouter();
  const marketplaceAddCashbackTransaction = useMarketplaceAddCashbackTransaction();
  const source = extractStringFromQuery(router.query, 'utm_source');
  const transactionId = extractStringFromQuery(router.query, 'transaction_id');
  useEffect(() => {
    if (source && transactionId) {
      marketplaceAddCashbackTransaction(source, transactionId);
    }
  }, [source, transactionId, marketplaceAddCashbackTransaction]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};
export default withClientOnly(CashbackTransactionDetector);